export default "__VITE_ASSET__BdiGssT7__"